import LangManager from './LangManager';

export default LangManager;
